import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

const ConfusedIcon = (props: IconProps) => {
  return (
    <Icon
      fill="none"
      viewBox="0 0 72 72"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
        <path fill="#FFCC4D" d="M72 36a36 36 0 1 1-72 0 36 36 0 0 1 72 0Z" />
        <path
          fill="#664500"
          d="M24 38.5c2.8 0 5-2.5 5-5.5s-2.2-5.5-5-5.5-5 2.5-5 5.5 2.2 5.5 5 5.5ZM48 40c2.8 0 5-3.1 5-7s-2.2-7-5-7-5 3.1-5 7 2.2 7 5 7ZM14.2 25.1a2 2 0 0 0 1.8.3c8.3-2.7 14 1.1 14.3 1.3a2 2 0 0 0 3-2c0-.5-.3-1-.7-1.3-.3-.2-7.5-5.2-17.9-1.8a2 2 0 0 0-.5 3.5ZM50 52H22a2 2 0 1 1 0-4h28a2 2 0 0 1 0 4Zm10-31.2c-.7 0-1.5-.3-2-1-2.7-3.4-8.6-6.5-10.6-6.5-1.3 0-3.8 1.8-5.2 3.1a2.5 2.5 0 0 1-3.5-3.6c.8-.7 4.9-4.5 8.7-4.5 4 0 11 4.1 14.6 8.5a2.5 2.5 0 0 1-2 4Z"
        />
    </Icon>
  );
};

export default ConfusedIcon;
